import styled from "styled-components";

const LoaderWrapper = styled.div`
	display: flex;
	align-items: center;
	transition: all 0.3s ease;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(255, 255, 255, 0.3);
	height: 100%;
	width: 100%;
	z-index: 2147483641;

	.loader {
		width: 4rem;
		height: 4rem;
		position: relative;
		margin: 10rem auto;
	}

	.double-bounce1,
	.double-bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: ${props => props.theme.green};
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;
		-webkit-animation: sk-bounce 2s infinite ease-in-out;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.double-bounce2 {
		animation-delay: -1s;
	}

	@keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}
`;

export default LoaderWrapper;
